var chunkMapping = {
	"0": [
		4718,
		4235
	],
	"74": [
		5127
	],
	"153": [
		5206
	],
	"154": [
		5207
	],
	"157": [
		5210
	],
	"158": [
		5211
	],
	"159": [
		5212
	],
	"160": [
		5213
	],
	"161": [
		5214
	],
	"162": [
		5215
	],
	"163": [
		5216
	],
	"164": [
		5217
	],
	"165": [
		5218
	],
	"166": [
		5219
	],
	"167": [
		5220
	],
	"168": [
		5221
	],
	"169": [
		5222
	],
	"170": [
		5223
	],
	"171": [
		5224
	],
	"172": [
		5225
	],
	"173": [
		5226
	]
};
var idToExternalAndNameMapping = {
	"4235": [
		"default",
		"./nuorder-components",
		4110
	],
	"4718": [
		"default",
		"./Containers",
		3795
	],
	"5127": [
		"default",
		"./OrderlessInvoices",
		3795
	],
	"5206": [
		"default",
		"./AsyncEventTracker",
		3795
	],
	"5207": [
		"default",
		"./HostWrapper",
		3795
	],
	"5210": [
		"default",
		"./CheckoutV3",
		3795
	],
	"5211": [
		"default",
		"./CheckoutConfirmation",
		3795
	],
	"5212": [
		"default",
		"./ContactCreditCards",
		3795
	],
	"5213": [
		"default",
		"./AuditDialog",
		3795
	],
	"5214": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3795
	],
	"5215": [
		"default",
		"./InvoiceDialog",
		3795
	],
	"5216": [
		"default",
		"./PaymentDueModal",
		3795
	],
	"5217": [
		"default",
		"./PaymentModal",
		3795
	],
	"5218": [
		"default",
		"./PaymentHistory",
		3795
	],
	"5219": [
		"default",
		"./PaymentConfigurations",
		3795
	],
	"5220": [
		"default",
		"./PaymentPreferences",
		3795
	],
	"5221": [
		"default",
		"./ManagePaymentProcessing",
		3795
	],
	"5222": [
		"default",
		"./MobilePaymentsWrapper",
		3795
	],
	"5223": [
		"default",
		"./Challenge",
		3795
	],
	"5224": [
		"default",
		"./ManagePaymentMethods",
		3795
	],
	"5225": [
		"default",
		"./LightspeedReports",
		3795
	],
	"5226": [
		"default",
		"./ShippingPromotionsListContainer",
		3795
	]
};
var idToRemoteMap = {
	"4235": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4110
		}
	],
	"4718": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5206": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5207": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5210": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5211": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5212": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5213": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5214": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5215": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5216": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5217": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5218": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5219": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5220": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5221": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5222": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5223": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5224": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5225": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5226": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}